"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.redactByRegExpPatterns = void 0;
require("core-js/modules/es6.array.find.js");
require("core-js/modules/es6.regexp.constructor.js");
require("core-js/modules/es6.regexp.replace.js");
var _appConfig = _interopRequireDefault(require("@nerdwallet/app-config"));
var _shared = require("./shared");
var _config$API;
/**
 * List of RegExp patterns to catch values which should not be logged.
 * 
 * These are defined in https://github.com/NerdWallet/app-configs/blob/master/global/default.yml
 *
 
 * @see https://eloquentjavascript.net/09_regexp.html
 */
var sensitiveValuePatterns = (_appConfig.default === null || _appConfig.default === void 0 ? void 0 : (_config$API = _appConfig.default.API) === null || _config$API === void 0 ? void 0 : _config$API.REDACTION_REGEXPS) || [];
var findApplicableRegExp = function findApplicableRegExp(str) {
  return sensitiveValuePatterns.find(function (pattern) {
    return (
      // avoid the pitfalls of stateful RegExps by creating a new RegExp for each invocation.
      new RegExp(pattern).test(str)
    );
  });
};

/**
 * This rule gets called for all strings that haven't already been redacted by another rule.
 *
 * If you are adding a RegExp here, please consider if you can _also_ add a rule to filter by
 * property name or some other criteria which might prevent the execution from reaching the string
 * X regexp stage (for instance, we want to avoid logging access_tokens, but if we redact the
 * entire request object (using the redactRequestProperty) rule then we can avoid recursing through
 * the request object, which would help us avoid becoming a performance bottleneck.
 */
var redactByRegExpPatterns = exports.redactByRegExpPatterns = {
  // Handle values matching certain regexps.
  test: function test(propertyName, value) {
    // We don't want to apply this rule to objects which may have a matching .toString because that
    // would prevent the object from being recursed and give us partial logs.
    if (typeof value === 'string') {
      var pattern = findApplicableRegExp(String(value));
      return !!pattern;
    }
    return false;
  },
  /**
   * We need to make sure we redact substrings (consider "123-12-1234" vs. "the ss number is
   * 123-12-1234"). But we only want to redact the sensistive info and not the entire string. This
   * means we must find the appropriate regexp pattern and then use String:replace function.
   */
  replacement: function replacement(value) {
    var str = String(value);
    var applicablePattern = findApplicableRegExp(value);
    /*
    1. This function is only expected to be invoked if we know that an applicablePattern exists
       (because we already called `.test`).
    2. Create a new RegExp because we need the RegExp in _this_ situation to be global, and /g
       alters the RegExp's internal state (.lastIndex).
    */
    return str.replace(new RegExp(applicablePattern, 'g'), _shared.Redacted);
  }
};